import { Grid, Stack } from '@mui/material';
import { useIntl } from 'react-intl';
import { TextFieldElementWithEmoji } from './TextFieldElementWithEmoji';

/** Shared title + content fields for social publish forms, with emoji pickers. */
export function TitleAndContentFieldsMui() {
  const { $t } = useIntl();
  return (
    <Stack spacing={4}>
      <Grid container>
        <Grid item md={12}>
          <TextFieldElementWithEmoji
            name="title"
            label={$t({
              id: 'socialExport.form.title',
              defaultMessage: 'Título',
            })}
            required
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container>
        <Grid item md={12}>
          <TextFieldElementWithEmoji
            name="content"
            label={$t({
              id: 'socialExport.form.content',
              defaultMessage: 'Contenido',
            })}
            required
            fullWidth
            multiline
            rows={3}
          />
        </Grid>
      </Grid>
    </Stack>
  );
}
